import React, { useState } from "react";

const API_BASE =
  (process.env.REACT_APP_API_URL || "https://makebeetrip.com")
    .replace(/\/+$/, "") + "/api";
export default function VisaEnquiryForm({
  initial = {},
  onDone,
  onCancel,
}) {
  const country = initial.country || {};

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const fullName = form.fullName.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    const message = form.message.trim();

    if (!fullName) {
      setError("Please enter your full name.");
      return;
    }

    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    if (!phone) {
      setError("Please enter your phone number.");
      return;
    }

    if (!initial.travelDate) {
      setError("Please select your travel date.");
      return;
    }

    if (!initial.visaType) {
      setError("Please select a visa type.");
      return;
    }

    setStatus("loading");
    setError("");

    try {
      const token = localStorage.getItem("mbt_token");

const response = await fetch(`${API_BASE}/admin/visa-enquiry`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  },
  body: JSON.stringify({
          fullName,
          email,
          phone,

          destinationCountry:
            country.name ||
            country.countryName ||
            country.country ||
            initial.countryName ||
            "",

          countryCode:
            country.code ||
            initial.countryCode ||
            "",

          visaType: initial.visaType,

          travellers: Number(initial.travellers) || 1,

          travelDate: initial.travelDate,

          message: message || null,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data.error || "Could not submit your enquiry. Please try again."
        );
      }

      setStatus("success");

      setTimeout(() => {
        onDone?.();
      }, 1800);
    } catch (err) {
      console.error("[VisaEnquiryForm] Submission failed:", err);

      setStatus("error");
      setError(
        err.message || "Could not submit your enquiry. Please try again."
      );
    }
  };

  if (status === "success") {
    return (
      <div className="visa-enquiry-form">
        <div className="visa-enquiry-success">
          <div className="visa-enquiry-success-icon" aria-hidden="true">
            ✓
          </div>

          <h2>Enquiry Submitted</h2>

          <p>
            Thank you for your enquiry. Our visa team will review your travel
            details and contact you shortly.
          </p>

          <div className="visa-enquiry-success-details">
            <strong>
              {country.name || initial.countryName || "Selected destination"}
            </strong>

            <span>
              {initial.visaType || "Visa"} ·{" "}
              {Number(initial.travellers) || 1} traveller
              {Number(initial.travellers) === 1 ? "" : "s"}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <form
      className="visa-enquiry-form"
      onSubmit={handleSubmit}
      noValidate
    >
      <div className="visa-enquiry-header">
        <div>
          <span className="visa-enquiry-eyebrow">Visa Assistance</span>

          <h2>Visa Enquiry</h2>

          <p>
            Share your travel plans and our visa team will guide you.
          </p>
        </div>
      </div>

      {/* Selected Visa Details */}
      <div className="visa-enquiry-summary">
        <div className="visa-enquiry-summary-heading">
          <span className="visa-enquiry-summary-icon" aria-hidden="true">
            ✈
          </span>

          <div>
            <strong>Your Visa Details</strong>
            <span>Based on your selection</span>
          </div>
        </div>

        <div className="visa-enquiry-summary-grid">
          <div className="visa-enquiry-summary-item">
            <span>Destination</span>
            <strong>
              {country.name ||
                initial.countryName ||
                initial.countryCode ||
                "—"}
            </strong>
          </div>

          <div className="visa-enquiry-summary-item">
            <span>Visa Type</span>
            <strong>{initial.visaType || "—"}</strong>
          </div>

          <div className="visa-enquiry-summary-item">
            <span>Travellers</span>
            <strong>
              {Number(initial.travellers) || 1}{" "}
              {Number(initial.travellers) === 1 ? "Traveller" : "Travellers"}
            </strong>
          </div>

          <div className="visa-enquiry-summary-item">
            <span>Travel Date</span>
            <strong>{initial.travelDate || "—"}</strong>
          </div>
        </div>
      </div>

      {/* Contact Details */}
      <div className="visa-enquiry-section">
        <div className="visa-enquiry-section-title">
          Your Contact Details
        </div>

        <div className="visa-enquiry-fields">
          <div className="visa-enquiry-field">
            <label htmlFor="visa-enquiry-full-name">
              Full Name <span>*</span>
            </label>

            <input
              id="visa-enquiry-full-name"
              name="fullName"
              type="text"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Enter your full name"
              autoComplete="name"
              disabled={status === "loading"}
            />
          </div>

          <div className="visa-enquiry-field">
            <label htmlFor="visa-enquiry-email">
              Email <span>*</span>
            </label>

            <input
              id="visa-enquiry-email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              autoComplete="email"
              disabled={status === "loading"}
            />
          </div>

          <div className="visa-enquiry-field visa-enquiry-field-full">
            <label htmlFor="visa-enquiry-phone">
              Phone <span>*</span>
            </label>

            <input
              id="visa-enquiry-phone"
              name="phone"
              type="tel"
              value={form.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              autoComplete="tel"
              inputMode="tel"
              disabled={status === "loading"}
            />
          </div>

          <div className="visa-enquiry-field visa-enquiry-field-full">
            <label htmlFor="visa-enquiry-message">
              Message <span className="optional">(Optional)</span>
            </label>

            <textarea
              id="visa-enquiry-message"
              name="message"
              rows="3"
              value={form.message}
              onChange={handleChange}
              placeholder="Tell us anything our visa team should know"
              disabled={status === "loading"}
            />
          </div>
        </div>
      </div>

      {error && (
        <div className="visa-enquiry-error" role="alert">
          {error}
        </div>
      )}

      <div className="visa-enquiry-actions">
        {onCancel && (
          <button
            type="button"
            className="visa-enquiry-cancel"
            onClick={onCancel}
            disabled={status === "loading"}
          >
            Back
          </button>
        )}

        <button
          type="submit"
          className="visa-enquiry-submit"
          disabled={status === "loading"}
        >
          {status === "loading" ? (
            <>
              <span className="visa-enquiry-spinner" aria-hidden="true" />
              Submitting...
            </>
          ) : (
            "Submit Enquiry"
          )}
        </button>
      </div>
    </form>
  );
}